import { Col } from 'antd';
import { CONTENT_SPAN } from 'constants/table';
import styled from 'styled-components';

export const SectionTitleStyle = styled.h4`
  font-weight: 500;
  font-size: 16px;
  width: 100%;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;
  text-align: ${(props) => (props.center ? 'center' : 'unset')};

  .info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    max-width: 71%;

    .right {
      justify-self: right;
    }
  }
`;

export function SectionTitle({ offset, children, style }) {
  return (
    <Col offset={offset || CONTENT_SPAN}>
      <SectionTitleStyle style={style}>{children}</SectionTitleStyle>
    </Col>
  );
}
